import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { FloatingActions } from "./components/FloatingActions";
import { CookieBanner } from "./components/CookieBanner";
import Home from "./pages/Home";
import InnerPage from "./pages/InnerPage";
import Contatti from "./pages/Contatti";
import Privacy from "./pages/Privacy";

const SLUGS = ["chi-siamo", "prodotti", "stampe", "allestimenti", "marketing", "press", "creativita", "gadget"];

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Header />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            {SLUGS.map((s) => <Route key={s} path={`/${s}`} element={<InnerPage slug={s} />} />)}
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy-cookie" element={<Privacy />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <FloatingActions />
        <CookieBanner />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
